import React, { useEffect, useRef, useState } from "react";
import classes from "./Login.module.scss";
import { LoadingButton } from "@mui/lab";
import logo from "../../../assets/logo192.png";
import LoginIcon from "@mui/icons-material/Login";
import { useTheme } from "@mui/material";
import LayoutFooter from "../../layout/LayoutFooter";

import { ErrorModal } from "../../modal/error/ErrorModal";
import { zoomState } from "../../../states/zoomState";
import { useRecoilState } from "recoil";
import { useLoginOAuth2 } from "../../../hooks/useLoginOAuth2";
// import "./style.scss";
const Login = () => {
  const theme = useTheme();
  // const titleRef = useRef<HTMLDivElement>(null);
  const titleRef = useRef<HTMLHeadingElement>(null);

  const [iconHover, setIconHover] = useState(false);
  const [titleStyle, setTitleStyle] = useState(`${classes.loginTitle}`);
  const [descStyle, setDescStyle] = useState(`${classes.loginDesc}`);
  const [boxStyle, setBoxStyle] = useState(`${classes.loginBox}`);
  const [buttonStyle, setButtonStyle] = useState(
    `${classes.btn} ${classes.slideBg}`
  );
  const [message, setMessage] = useState("Google認証に失敗しました");
  const [isShowErrorDialog, setIsShowErrorDialog] = useState(false);
  const [title, setTitle] = useState("ログインエラー");
  const { login, loading, error } = useLoginOAuth2();
  //ログインボタンクリック
  const onClickLogin = async () => {
    try {
      await login();
    } catch (error) {
      //モーダル表示
      setMessage("Google認証に失敗しました");
      setIsShowErrorDialog(true);
    } finally {
    }
  };
  //アニメーションの実行
  useEffect(() => {
    setTitleStyle(`${classes.loginTitle} ${classes.inview}`);
    setDescStyle(`${classes.loginDesc} ${classes.inview}`);
    setBoxStyle(`${classes.loginBox} ${classes.inview}`);
  }, []);
  // return (
  //   <>
  //     <div id="container">
  //       <div className={boxStyle}>
  //         <img className={classes.imgZoom} src={logo} alt="" />
  //       </div>
  //     </div>
  //   </>
  // );
  const [zoomLevel, setZoomLevel] = useRecoilState(zoomState);
  return (
    <div
      className={classes.login}
      style={{
        transform: `scale(${1 / Number(zoomLevel)})`,
        // transformOrigin: "center top", // 中央上部を起点にスケーリング
        transformOrigin: "0 0",
        width: `${Number(zoomLevel) * 100}%`, // 親コンテナの幅を調整
        height: `${Number(zoomLevel) * 100}%`, // 親コンテナの高さを調整
        overflow: "visible", // 見切れ防止
      }}
    >
      <div className={classes.loginWrapper}>
        <div className={classes.loginLeft}>
          <h3 className={titleStyle}>
            {/* <div className="animate-title" ref={titleRef}> */}
            <span className={classes.char}>S</span>
            <span className={classes.char}>i</span>
            <span className={classes.char}>t</span>
            <span className={classes.char}>e</span>
            <span className={classes.char}>&nbsp;</span>
            <span className={classes.char}>D</span>
            <span className={classes.char}>I</span>
            <span className={classes.char}>A</span>
            <span className={classes.char}>R</span>
            <span className={classes.char}>Y</span>
          </h3>
          <span className={descStyle}>
            <span className={classes.char}>現</span>
            <span className={classes.char}>場</span>
            <span className={classes.char}>日</span>
            <span className={classes.char}>報</span>
            <span className={classes.char}>入</span>
            <span className={classes.char}>力</span>
          </span>
        </div>
        <div className={classes.loginRight}>
          <div className={boxStyle}>
            <div className={classes.loginLogo}>
              <img src={logo} alt="" />
            </div>

            <LoadingButton
              onMouseEnter={() => setIconHover(true)} // マウスがアイコン上に入る
              onMouseLeave={() => setIconHover(false)} // マウスがアイコンから離れる
              onClick={onClickLogin}
              loadingPosition="end"
              className={classes.button + " " + classes.slideBg}
              endIcon={
                <LoginIcon
                  style={{
                    color: iconHover
                      ? theme.palette.foreColor.light
                      : theme.palette.backColor.dark,
                  }}
                />
              }
              loading={loading}
              variant="contained"
              /* sx={{
              //   color: theme.palette.foreColor.light,
              //   backgroundColor: theme.palette.backColor.dark,
              //   "&:hover": {
              //     backgroundColor: theme.palette.backColor.main,
              //     color: theme.palette.foreColor.main,
              //   },
              // }}
              */
            >
              Log in
            </LoadingButton>
          </div>
        </div>
      </div>
      <LayoutFooter />
      {isShowErrorDialog && (
        <ErrorModal
          title={title}
          message={message}
          setIsShow={setIsShowErrorDialog}
        />
      )}
    </div>
  );
};

export default Login;
